export default "__VITE_ASSET__DjKfNiOA__$_?nuxt_component=async&nuxt_component_name=SvgoUserKycCardFront&nuxt_component_export=default__"